<form-popup [(visible)]="visible" 
            (visibleChange)="onVisibleChange($event)"
            (save)="onPopupSaveClick()" 
            [titleText]="titlePrefix ? titlePrefix + ' Shunt Move' : 'Shunt Move'"
            [isSaveDisabled]="isReadOnly">
    <dx-form class="plain-styled-form" [screenByWidth]="getSizeQualifier">
        <dxi-item itemType="group">
            <dxo-col-count-by-screen
                [xs]="1"
                [sm]="3"
                [md]="3"
                [lg]="3"
            ></dxo-col-count-by-screen>
            <dxi-item [colSpan]="3">
                <dx-select-box
                    label="Location:*"
                    stylingMode='filled'
                    valueExpr="value"
                    displayExpr="text"
                    [items]="shuntLocationOptions"
                    [(value)]="formData.location"
                    (onValueChanged)="onLocationTypeChanged($event)"
                    [readOnly]="isReadOnly"
                >
                    <dx-validator>
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                </dx-select-box>
            </dxi-item>
            <dxi-item [colSpan]="2">
                <dx-select-box            
                    label="Location #:*"
                    stylingMode="filled"
                    valueExpr="id"
                    displayExpr="number"
                    [(value)]="formData.locationId"
                    (onValueChanged)="onValueChanged($event.value)"
                    [dataSource]="shuntLocationDataSource"
                    placeholder="Select a location"
                    [searchEnabled]="true"
                    [readOnly]="isReadOnly"
                >
                    <dx-validator>
                            <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                </dx-select-box>
            </dxi-item>
            <dxi-item [colSpan]="1">
                <dx-select-box
                    label="Priority:*"
                    stylingMode='filled'
                    valueExpr="value"
                    displayExpr="text"
                    [items]="shuntPriorityOptions"
                    [(value)]="formData.priority"
                    [readOnly]="isReadOnly"
                >
                    <dx-validator>
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                </dx-select-box>
            </dxi-item>
            <dxi-item [colSpan]="3">
                <dx-text-area
                    label="Note to Shunt Driver:"
                    [(value)]="formData.note"
                    stylingMode='filled'
                    maxLength="20"
                    [readOnly]="isReadOnly"
                >
                </dx-text-area>
            </dxi-item>
        </dxi-item>
    </dx-form>
</form-popup>